import styled from "styled-components";

import rem from "../../utils/rem";

const TooltipInformer = styled.span`
  background-color: ${({ theme }) => theme.colors.primary.base};
  border-radius: 50%;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;

  svg {
    font-size: ${rem(9)};
    color: #ffffff;
  }
`;

export default TooltipInformer;
